(function() {
  this.app = {
    _body: $("body"),
    _window: window,
    _vw: this.innerWidth,
    _vh: this.innerHeight,
    _vh_middle: this.innerHeight / 2,
    _language: null,
    _ax: 0,
    _ay: 0,
    _avx: 0,
    _avy: 0,
    _aax: 0,
    _aay: 0,
    _interval: null,
    _isios: false,
    _isandroid: false,
    _ischrome: false,
    _issafari: false,
    _istablet: false,
    _ismobile: false,
    _isportrait: false,
    _ishome: false,
    _ismission: false,
    _isgallery: false,
    _ispv: false,
    _cookie_state: false,
    _isloaded: false,
    _h_slider: null,
    _gallery: null,
    _col_slider: $(".col-slider"),
    _scrollbar: null,
    _nav_bar: $("#w_t_bar"),
    _h_s_controls: null,
    _anim_items_selector: $(".anim_item"),
    _has_scroll_selector: $(".h-scroll"),
    _is_scroll: false,
    _offset: 0,
    _previus_scroll: null,
    _p_id: null,
    _is_resized: false,
    _setlocal: true,
    _baseurl: document.location.origin + "/",
    // _baseurl: document.location.origin,
    _lat: null,
    _lng: null,
    _map: null,
    _markers: [],
    _city_markers: null,
    _infowindow: [],
    _all_products_list: null,
    check_device: function() {
      var _html = $("html");
      if (_html.hasClass("ios")) this._isios = true;
      if (_html.hasClass("android")) this._isandroid = true;
      if (_html.hasClass("chrome")) this._ischrome = true;
      if (_html.hasClass("safari")) this._issafari = true;
      if (_html.hasClass("tablet")) this._istablet = true;
      if (_html.hasClass("mobile")) this._ismobile = true;
      if (_html.hasClass("portrait")) this._isportrait = true;
      if (this.check_element($("#home_slideshow"))) this._ishome = true;
      if (
        this.check_element($("#product_gallery")) ||
        this.check_element($("#subcategory_gallery"))
      )
        this._isgallery = true;
      if (this.check_element($("#subcategory_background")))
        this._isSubcat = true;
      if (this.check_element($("#punti_vendita_header"))) this._ispv = true;
      if (this.check_element($("#azienda_mission"))) this._ismission = true;
    },
    check_storage: function() {
      var _this = this;
      var mui = ".mui-select";
      if (typeof Storage !== "undefined") {
        var url = window.location.pathname;

        if (localStorage.getItem("state") != "changed") {
          localStorage.setItem("mercato", "italiano");
          localStorage.setItem("state", "start");
        }

        if (localStorage.getItem("cookie-state") != 1) {
          localStorage.setItem("cookie-state", 1);

          $.ajax({
            type: "POST",
            url: _this._baseurl + "it/setcookiemarket",
            dataType: "json",
            data: {
              market: localStorage.getItem("mercato"),
            },
            success: function(result) { },
            error: function() { },
          });
        }

        if (localStorage.getItem("mercato") !== null) {
          if (url.indexOf("/choose-market/") != -1) window.location.href = "/";

          this._setlocal = true;

          var mercato = "estero";
          var lang = _this._language;

          if (localStorage.getItem("mercato") == "estero") {
            switch (lang) {
              case "it":
                mercato = "estero";
                break;
              case "en":
                mercato = "foreign";
                break;
              case "fr":
                mercato = "étranger";
                break;
            }
            $('.w-market-m ul li a[data-market="ch"]')
              .html(mercato)
              .addClass("active");
          }

          if (localStorage.getItem("mercato") == "italiano") {
            switch (lang) {
              case "it":
                mercato = "italiano";
                break;
              case "en":
                mercato = "italian";
                break;
              case "fr":
                mercato = "italien";
                break;
            }
            $('.w-market-m ul li a[data-market="ch"]')
              .text(mercato)
              .addClass("active");
          }
        }
      } else {
        console.log("Warning! No Web Storage support.");
      }
    },
    change_market: function() {
      if (localStorage.getItem("mercato") == "italiano")
        localStorage.setItem("mercato", "estero");
      else localStorage.setItem("mercato", "italiano");

      localStorage.setItem("state", "changed");
      localStorage.setItem("cookie-state", 0);
      var _this = this;

      var href = window.location.origin;

      if (_this._language != "it")
        href = window.location.origin + "/" + _this._language + "/";

      $.ajax({
        type: "POST",
        url: _this._baseurl + "it/unsetcookiemarket",
        dataType: "json",
        data: {},
        success: function(result) {
          $.ajax({
            type: "POST",
            url: _this._baseurl + "it/setcookiemarket",
            dataType: "json",
            data: {
              market: localStorage.getItem("mercato"),
            },
            success: function(result) {
              _this.start_page_animation(href);
            },
            error: function() { },
          });
        },
        error: function() { },
      });
    },
    init: function() {
      this._language = $("#w-loader").data("lang");

      this.check_storage();

      this._p_id = $("footer").attr("id");
      var _this = this;
      this.check_device();

      if (!this._istablet && !this._ismobile && this._vw > 1260) {
        $("html, body").css({
          "overflow-y": "hidden",
        });
      }

      if (!this._istablet && !this._ismobile && this._vw > 1260)
        this._body.addClass("s_sb");

      if (this._ismobile) {
        $("header nav .m-img-bg").remove();
        $("header nav .w-m-header").remove();
      }
      $("#bg-loader").addClass("start");
      $("a.a_link").on("click", function(e) {
        var href = $(this).attr("href");
        e.preventDefault();
        _this.start_page_animation(href);
      });
    },
    init_events: function() {
      var _this = this;
      $(".cc-compliance").on("click", "a", function() {
        cookie_state = true;
        $("#fb-home").show();
        _this.setSelectors();
        _this.transform_elements();
      });
      if (this.check_element($(".hamb"))) {
        $(".w-hamb").on("click", function() {
          _this.open_menu(true);
        });
        $(".m-closer").on("click", function() {
          _this.open_menu(false);
        });
      }

      $(".chiudi_old").click(function(e) {
        e.preventDefault();
        $("#old_browsers").hide();
      });

      if (this.check_element($(".w_b_gallery"))) {
        var wbgallery = $(".w_b_gallery");
        for (var i = 0; i < wbgallery.length; i++) {
          var id_gallery = $(wbgallery[i]).attr("id");
          $("#" + id_gallery + " a").fancybox({
            hash: false,
            loop: true,
            infobar: false,
            //animationEffect : false,
            clickContent: false,
            transitionEffect: "slide",
            buttons: [
              //"zoom",
              //"share",
              //"slideShow",
              //"fullScreen",
              //"download",
              //"thumbs",
              "close",
            ],
            btnTpl: {
              close:
                '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
                '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve"><g><g><rect x="48.3" y="-1.4" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -21.5213 50.5429)" width="4" height="105.4"></rect></g><g><rect x="-2.4" y="49.3" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -21.5213 50.5429)" width="105.4" height="4"></rect></g></g></svg>' +
                "</button>",

              arrowLeft:
                '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
                '<div><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;" viewBox="0 0 385 741" x="0px" y="0px" fill-rule="evenodd" clip-rule="evenodd"><g><polygon class="fil0" points="0,371 371,0 385,15 29,371 385,727 371,741 "></polygon></g></svg></div>' +
                "</button>",

              arrowRight:
                '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
                '<div><svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve"><g><polygon points="227.9,149.8 77.7,300 72.1,293.9 216.2,149.8 72.1,5.7 77.7,0 	"/></g></svg></div>' +
                "</button>",
            },
          });
        }
      }

      if (this._isSubcat) {
        $(".h-a-play-icon").on("click", function() {
          _this.load_h_iframe();
        });

        $("#w-video-player").click(function() {
          _this.unload_h_iframe();
        });
      }

      if (this._ishome) {
        $(".h-a-play-icon").on("click", function() {
          _this.load_h_iframe();
        });

        $("#w-video-player").click(function() {
          _this.unload_h_iframe();
        });

        $("#home_punti_vendita").on("click", "a", function(e) {
          e.preventDefault();
          var href = $(this).attr("href");
          var city = $("#h-pv-i").val();
          if (city !== "" && !$.isNumeric(city)) {
            /* SET STORAGE CITY*/
            localStorage.setItem("city", city);
            _this.start_page_animation(href);
          } else {
            _this.start_page_animation(href);
          }
        });

        $("#h-pv-i").on("keypress", function(e) {
          if (e.which == 13) {
            $("#home_punti_vendita a").click();
            return false;
          }
        });

        $("#home_punti_vendita")
          .find(".sender")
          .on("click", function() {
            $("#home_punti_vendita a").click();
          });
      }

      $(".w-market-m").on("click", "a", function() {
        if ($(this).hasClass("active")) return false;

        _this.change_market();
      });

      if (this.check_element($("#subcategory_colors"))) {
        $("#link_fc").on("click", "a", function() {
          var pos = 0;
          if (_this._scrollbar) {
            pos =
              $("#subcategory_qualita").innerHeight() +
              $("#subcategory_qualita").offset().top +
              _this._scrollbar.scrollTop -
              20;
            _this._scrollbar.scrollTo(0, pos, 1500);
          } else {
            pos = $("#subcategory_colors").offset().top - 100;
            $("html, body").animate({
              scrollTop: pos,
            });
          }
        });

        var svg = $("#subcategory_colors").find("svg");

        var selection = function(target) {
          svg.find(".poly").css({
            fill: "#fff",
          });

          svg.find("." + target).css({
            fill: "#37424a",
          });

          $(".colors-menu li a").removeClass("active");
          $(".colors-menu")
            .find('a[data-target="' + target + '"]')
            .addClass("active");

          _this.get_gallery_contents(target);
        };

        $(".colors-menu")
          .on("click", "a", function() {
            $(".w-svg").find(".poly").removeClass("hovered");

            if ($(this).hasClass("active")) return;

            var target = $(this).data("target");

            selection(target);
          })
          .on("mouseover", "a", function() {
            var item = $(this);

            if (item.hasClass("active") || _this._istablet || _this._ismobile)
              return;

            var target = item.data("target");

            $(".w-svg")
              .find("." + target)
              .addClass("hovered");
          })
          .on("mouseout", "a", function() {
            var item = $(this);

            if (item.hasClass("active") || _this._istablet || _this._ismobile)
              return;

            var target = item.data("target");

            $(".w-svg")
              .find("." + target)
              .removeClass("hovered");
          });

        svg
          .find(".poly")
          .on("click", function() {
            $(".colors-menu li a").removeClass("hovered");

            var target = $(this).data("t");

            if (
              $(".colors-menu li a[data-target='" + target + "']").hasClass(
                "active",
              )
            )
              return;

            selection($(this).data("t"));
          })
          .on("mouseover", function() {
            var item = $(this);
            var target = item.data("t");

            if (
              item.css("fill") == "rgb(55, 66, 74)" ||
              _this._istablet ||
              _this._ismobile
            )
              return;

            $(".colors-menu li a[data-target='" + target + "']").addClass(
              "hovered",
            );
          })
          .on("mouseout", function() {
            var item = $(this);
            var target = item.data("t");

            $(".colors-menu li a[data-target='" + target + "']").removeClass(
              "hovered",
            );
          });
      }

      if (_this._ispv) {
        $("#find-stores").on("click", function() {
          var city = $("#pv-i").val();

          if (city === "" || $.isNumeric(city)) return;

          $("#pv-i").blur();

          $("#punti_vendita_header .w_i_loader").show();

          _this.search_locations(city);
        });

        $("#pv-i").on("keypress", function(e) {
          if (e.which == 13) {
            $("#find-stores").click();
            return false;
          }
        });

        $("#wrapper_map .to-find").on("click", function() {
          var btn = $(this);

          if (this._istablet || this._ismobile) {
            $("#pv-i").val("").blur();
          } else $("#pv-i").val("").focus();

          if (_this._scrollbar) {
            _this._scrollbar.scrollTo(0, 0, 1200, function() {
              if (_this._city_markers) _this._city_markers.setMap(null);

              for (var i = 0; i < _this._markers.length; i++) {
                _this._infowindow[i].close();
              }

              btn.removeClass("showed");

              _this._map.setZoom(6);
            });
          } else {
            if (_this._ismobile || _this._istablet) $("#pv-i").val("").blur();
            else $("#pv-i").val("").focus();

            $("html,body").animate(
              {
                scrollTop: 0,
              },
              500,
              function() {
                if (_this._city_markers) _this._city_markers.setMap(null);

                for (var i = 0; i < _this._markers.length; i++) {
                  _this._infowindow[i].close();
                }

                btn.removeClass("showed");

                _this._map.setZoom(6);
                _this._map.setCenter({ lat: 41.2052331, lng: 8.0840762 });
              },
            );
          }
        });
      }

      $(".w-search").on("click", function() {
        $("#h-s-controls").toggle();
        $("#search_wrapper").show();

        _this._body.css({
          overflow: "hidden",
        });

        $.ajax({
          type: "POST",
          url: _this._baseurl + "it/getallproducts",
          dataType: "json",
          data: {
            lang: _this._language,
          },
          success: function(result) {
            _this._all_products_list = result;
          },
          error: function() { },
        });

        $(this).toggle();

        $("#search_wrapper").toggleClass("open");
        setTimeout(function() {
          $("#search-i").focus().val("");
        }, 200);
      });

      $(".search_box .closer").on("click", function() {
        $("#search_wrapper").toggleClass("open");
        $(".w-search").toggle();
        $("#suggestions-select").hide().find("ul").empty();
        $("#h-s-controls").toggle();
        $("#search-i").val("").blur();
        var result_c = $("#result_container");
        setTimeout(function() {
          _this._body.css({
            overflow: "auto",
          });
          result_c.empty();
          $("#search_wrapper").show();
        }, 500);
      });

      $(".search_box .sender").on("click", function() {
        var ul = $("#suggestions-select").find("ul");
        if (ul.find("li").length == 0) return;
        _this.make_search_thumb(null);
      });

      $("#search-i")
        .on("keyup", function(e) {
          var _this_i = $(this);
          var val = $(this).val();
          val = val.toLowerCase();
          var ul = $("#suggestions-select").find("ul");

          //if(e.keyCode === 8 || e.keyCode === 46)
          if (e.keyCode === 13) {
            $("#search-i").focusout();
            $(".search_box .sender").click();
            return;
          }

          ul.empty();

          $("#suggestions-select p").hide();

          if (val.length > 1) {
            $.each(_this._all_products_list, function(index, value) {
              if (value.name.indexOf(val) != -1) {
                var type = value.type;
                var h6 = "";
                switch (_this._language) {
                  case "it":
                    h6 =
                      "cucine <span>" +
                      (value.category == 4 ? "classiche" : "moderne") +
                      "</span>";
                    break;

                  case "en":
                    h6 =
                      "kitchens <span>" +
                      (value.category == 4 ? "classiche" : "moderne") +
                      "</span>";
                    break;

                  case "fr":
                    h6 =
                      "cousins <span>" +
                      (value.category == 4 ? "classiche" : "moderne") +
                      "</span>";
                    break;
                }
                var li =
                  '<li data-name="' +
                  value.name +
                  '" data-cucina="' +
                  value.category +
                  '" data-thumb="' +
                  value.thumb +
                  '" data-type="' +
                  value.type +
                  '" data-id="' +
                  value.id +
                  '">' +
                  "<h6>" +
                  h6 +
                  "</h6>" +
                  "<span>" +
                  value.name +
                  '<span class="suggestion-type"> ' +
                  type +
                  "</span></span>" +
                  "</li>";
                ul.append(li);
              }
            });

            var li_list = ul.find("li");
            _this_i.attr("data-nitems", li_list.length);
            if (li_list.length > 0) $("#suggestions-select").show();
          }
        })
        .on("focusout", function() {
          var result_c = $("#result_container");
          var ul = $("#suggestions-select").find("ul");
          var nitems = $(this).attr("data-nitems");
          if (nitems == 0 && $(this).val() != "") {
            result_c.empty();
            $("#suggestions-select p").show().fadeTo(200, 1);
          }
        });

      $("#suggestions-select ul").on("click", "li", function() {
        var s_s = $("#suggestions-select");
        var s_b = $(".search_box");
        var name = $(this).data("name");
        $("#search-i").val(name);
        //s_s.hide().find("ul").empty();
        /*var tot = _this._vh - s_b.position().top - 30 - 4;
        s_b.css({
        'height': tot+'px'
      });*/
        _this.make_search_thumb($(this).index());
      });

      $("#newsletter_sender").on("click", function() {
        var n_value = $("#f-newsletter-i").val();
        var alert = $(".f_alert");
        $("#f-newsletter-i").on("focus", function() {
          alert.hide().removeClass("error success show");
        });
        alert.removeClass("error success show").show();
        alert.on("click", function() {
          $(this).hide().removeClass("error success show");
        });
        var p = alert.find("p");
        var text = "";
        if (_this.validate_email(n_value) && n_value != "") {
          $.ajax({
            type: "POST",
            url: _this._baseurl + "it/addemailnewsletter",
            dataType: "json",
            data: {
              email: n_value,
              lang: _this._language,
            },
            success: function(result) {
              text = "Registrazione avvenuta con successo";

              switch (_this._language) {
                case "en":
                  text = "Registration completed successfully";
                  break;
                case "fr":
                  text = "Enregistrement terminé avec succès";
                  break;
              }
              p.text(text);
              alert.addClass("success show");
              return true;
            },
            error: function(result) {
              text = "Utente già registrato";
              switch (_this._language) {
                case "en":
                  text = "Already registered user";
                  break;
                case "fr":
                  text = "Email invalide";
                  break;
              }
              p.text(text);
              alert.addClass("error show");
              return false;
            },
          });
        } else {
          text = "Email non valida";
          switch (_this._language) {
            case "en":
              text = "Invalid email";
              break;
            case "fr":
              text = "Email invalide";
              break;
          }
          p.text(text);
          alert.addClass("error show");
          return false;
        }
      });

      /* NEWSLETTER EVENTS */

      $("#unsubscribe_ok").on("click", function() {
        $.ajax({
          type: "POST",
          url: _this._baseurl + "it/deleteemailnewsletter",
          dataType: "json",
          data: {
            id: $(this).attr("data-id"),
            delkey: $(this).attr("data-delkey"),
          },
          success: function(result) {
            $("#unsubscribe_newsletter").hide();
            $("#unsubscribe_done").show();
          },
          error: function(result) { },
        });
      });

      /* SUBCATEGORY PLAY VIDEO */

      $("#playSubcategory").on("click", function() {
        _this.load_subcatplay_iframe(this);
      });

      /*if(this._istablet || this._ismobile){
      $("figure.acc_img").on("click",function(){
      if($(this).parent().attr("href") === undefined){
      
      if(_this.check_element($("#w-gallery-grid")))
      $("#w-gallery-grid").remove();
      
      var html = '<div id="w-gallery-grid">';
      html += '<div class="w_i_loader">';
      html += '<div class="infinite-loader"></div>';
      html += '</div>';
      html += '<div id="w-img"><img src=""/></div>';
      html += '</div>';
      $("body").append(html);
      
      var img_url = '';
      
      if($(this).css("background-image") != 'none')
      img_url = $(this).css("background-image");
      else
      img_url = $(this).find("div").css("background-image");
      
      img_url = img_url.replace("url(\"", "");
      img_url = img_url.replace('")','');
      
      var r_url = img_url.split("/public/");
      r_url = '/public/'+ r_url[1];
      r_url = r_url.replace(')','');
      
      var ratio = $(this).width() / $(this).height() > 1;
      var landscapeOrientation = _this._vw/_this._vh > 1;
      var data = {
      'prop':'',
      'i_prop':'',
      'value':null
      };
      
      if(ratio){
      //horizontal image
      data.width = 'auto';
      data.height = _this._vh;
      
      }
      else{
      //vertical image
      data.width = 'auto';
      data.height = _this._vh;
      }
      
      $("#w-img").find("img").attr("src",r_url).css({
      'width': data.width,
      'height': data.height
      
      }).on("click",function(){
      
      clearInterval(_this._interval);
      $("#w-gallery-grid").removeAttr("class");
      
      });
      
      $("#w-gallery-grid").addClass("is-open");
      
      if (window.DeviceMotionEvent != undefined) {
      window.ondevicemotion = function(e) {
      _this._aax = event.accelerationIncludingGravity.x * 5;
      _this._aay = event.accelerationIncludingGravity.y * 5;
      }
      _this._interval = setInterval( function() {
      
      if ( landscapeOrientation) {
      _this._avx = _this._avx + _this._aay;
      _this._avy = _this._avy + _this._aax;
      } else {
      _this._avy = _this._avy - _this._aay;
      _this._avx = _this._avx + _this._aax;
      }
      _this._avx = _this._avx * 0.98;
      _this._avy = _this._avy * 0.98;
      _this._ay = parseInt(_this._ay + _this._avy / 50);
      _this._ax = parseInt(_this._ax + _this._avx / 50);
      
      _this.box_check();
      
      /!*if (!ratio)
      $("#w-img").scrollTop(_this._ay);
      else*!/
      $("#w-img").scrollLeft(_this._ax);
      
      
      }, 5);
      }
      }
      });
      }*/
    },
    validate_email: function(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    make_search_thumb: function(index) {
      var _this = this;
      var ul = $("#suggestions-select").find("ul");
      var li_list = ul.find("li");
      var result_c = $("#result_container");

      result_c.empty();

      var starter;

      if (index !== null) starter = index;
      else starter = 0;

      var ntot;
      if (index !== null) ntot = starter + 1;
      else ntot = li_list.length;

      var html = '<div class="row no-margin inner-results">';
      var html_moderne = "";
      var html_classiche = "";

      if (ul.find("li[data-cucina='5']").length > 0) {
        /* cucine moderne */
        var title = "Cucine <span>Moderne</span>";
        html_moderne +=
          '<div class="c_s_12 no-padding">' +
          "<h5>" +
          title +
          "</h5>" +
          '<div id="moderne_search_result" class="c_s_12">' +
          "</div>" +
          "</div>";

        if (index !== null && $(li_list[index]).data("cucina") != 5)
          html_moderne = "";
      }

      if (ul.find("li[data-cucina='4']").length > 0) {
        /* cucine classiche */
        var title = "Cucine <span>Classiche</span>";
        html_classiche +=
          '<div class="c_s_12 no-padding">' +
          "<h5>" +
          title +
          "</h5>" +
          '<div id="classiche_search_result" class="c_s_12">' +
          "</div>" +
          "</div>";

        if (index !== null && $(li_list[index]).data("cucina") != 4)
          html_classiche = "";
      }

      result_c.append(html + html_moderne + html_classiche + "</div>");

      for (var i = starter; i < ntot; i++) {
        var li = $(li_list[i]);
        var id = li.data("id");
        var type = li.data("type");
        var thumb = li.data("thumb");
        var name = li.data("name");
        var cucina = li.data("cucina");

        var item =
          '<div class="c_m_4 c_s_6 c_s_p">' +
          '<a class="a_link" href="/' +
          _this._language +
          "/" +
          name +
          '/">' +
          '<div class="w_i_loader">' +
          '<div class="infinite-loader"></div>' +
          "</div>" +
          "<figure>" +
          '<img src="/public/images/thumbs/' +
          thumb +
          '" class="img-responsive"/>' +
          '<div class="img-bg" style="background-image: url(/public/images/thumbs/' +
          thumb +
          ')"></div>' +
          '<div class="filter"></div>' +
          '<div class="w-btn">' +
          "<h3>scopri di più</h3>" +
          "</div>" +
          "<figcaption>" +
          '<div class="w-txt">' +
          "<h4>" +
          name +
          "</h4>" +
          "<p>" +
          type +
          "</p>" +
          "</div>" +
          "</figcaption>" +
          "</figure>" +
          "</a>" +
          "</div>";

        if (cucina == 4) {
          $("#classiche_search_result").append(item);
        }

        if (cucina == 5) {
          $("#moderne_search_result").append(item);
        }
      }

      result_c.waitForImages(
        function() {
          //alert('All images have loaded.');
        },
        function(loaded, count, success) {
          //alert(loaded + ' of ' + count + ' images has ' + (success ? 'loaded' : 'failed to load') +  '.');
          var figure = $(this).parent();
          var a = $(this).parents("a");
          a.find(".w_i_loader").remove();
          figure.fadeTo(400, 1);
        },
      );

      ul.empty();
    },
    search_locations: function(city) {
      var _this = this;
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: city }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          _this._lat = results[0].geometry.location.lat();
          _this._lng = results[0].geometry.location.lng();
          _this.find_clotest_market(_this._lat, _this._lng);
        } else {
          console.log("City not found.");
        }
      });
    },
    rad: function(x) {
      return (x * Math.PI) / 180;
    },
    find_clotest_market: function(lat, lng) {
      var _this = this;
      var R = 6371; /* radius of earth in km */
      var distances = [];
      var closest = -1;

      for (var i = 0; i < _this._markers.length; i++) {
        var mlat = _this._markers[i].getPosition().lat();
        var mlng = _this._markers[i].getPosition().lng();

        var dLat = _this.rad(mlat - lat);
        var dLong = _this.rad(mlng - lng);

        var a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(_this.rad(lat)) *
          Math.cos(_this.rad(lng)) *
          Math.sin(dLong / 2) *
          Math.sin(dLong / 2);

        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;

        distances[i] = d;

        if (closest == -1 || d < distances[closest]) {
          closest = i;
        }

        _this._infowindow[i].close();
      }

      if (_this._city_markers) _this._city_markers.setMap(null);

      _this._city_markers = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: _this._map,
      });

      $("#wrapper_map .to-find").addClass("showed");

      var bounds = new google.maps.LatLngBounds();
      bounds.extend(_this._markers[closest].getPosition());
      bounds.extend(_this._city_markers.getPosition());
      _this._map.fitBounds(bounds);

      _this._map.setZoom(_this._map.getZoom() - 1);

      if (_this._scrollbar) {
        setTimeout(function() {
          var pos =
            $("#punti_vendita_header").innerHeight() +
            $("#punti_vendita_header").offset().top +
            _this._scrollbar.scrollTop -
            80;
          _this._scrollbar.scrollTo(0, pos, 1500, function() {
            $("#punti_vendita_header .w_i_loader").hide();
          });
        }, 800);
      } else {
        var diff = 80;
        //if(_this._istablet && _this._isios)
        //diff =25;

        var pos = $("#wrapper_map").position().top - diff;
        $("html,body").animate(
          {
            scrollTop: pos,
          },
          500,
          function() {
            $("#punti_vendita_header .w_i_loader").hide();
          },
        );
      }

      google.maps.event.trigger(_this._markers[closest], "click");
    },
    init_map: function() {
      var _this = this;

      _this._map = new google.maps.Map(document.getElementById("map"), {
        zoom: 6,
        center: { lat: 41.2052331, lng: 8.0840762 } /* Italy */,
        scrollwheel: false,
        styles: [
          {
            featureType: "administrative",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#444444",
              },
            ],
          },
          {
            featureType: "landscape",
            elementType: "all",
            stylers: [
              {
                color: "#f2f2f2",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "all",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "all",
            stylers: [
              {
                saturation: -100,
              },
              {
                lightness: 45,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "all",
            stylers: [
              {
                visibility: "simplified",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "all",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: [
              {
                color: "#37424a",
              },
              {
                visibility: "on",
              },
            ],
          },
        ],
      });

      $.ajax({
        type: "POST",
        url: _this._baseurl + "it/getallstores",
        dataType: "json",
        data: {},
        success: function(result) {
          var image = "/public/userfiles/images/mapicons/mondoconv.png";
          var contentString = "";

          $.each(result, function(key, value) {
            contentString =
              '<div id="content">' +
              '<div id="siteNotice">' +
              "</div>" +
              '<h4 id="firstHeading" class="firstHeading" style="margin-top: 5px; margin-bottom: 5px;">' +
              value.name +
              "</h4>" +
              '<div id="bodyContent">' +
              '<p style="margin-top: 0; margin-bottom: 5px;">' +
              value.address +
              "</p>" +
              "</div>" +
              "</div>";

            _this._infowindow[key] = new google.maps.InfoWindow({
              content: contentString,
            });

            var lat_lng = { lat: value.lat, lng: value.lng };
            _this._markers[key] = new google.maps.Marker({
              position: lat_lng,
              map: _this._map,
              icon: image,
            });

            _this._markers[key].addListener("click", function() {
              _this._infowindow[key].open(_this._map, _this._markers[key]);
            });
          });
        },
        error: function() { },
      });
    },

    get_gallery_contents: function(t) {
      var _this = this;
      var item = $("#subcategory_colors");

      $.ajax({
        type: "POST",
        url: "/it/getgallerycontents",
        data: {
          target: t,
          id: item.data("id"),
          lang: item.data("lang"),
        },
        success: function(result) {
          var obj = jQuery.parseJSON(result);

          _this._col_slider.slick("slickGoTo", 0);

          $("#subcategory_colors .w-c-slider .c-slide figure").each(
            function(i) {
              var figure = $(this);
              var bg = $(this).find(".bg");

              bg.removeClass("load unload");

              var f_delay = 0.41;
              var d = parseFloat(i / 10 + f_delay).toFixed(2);
              _this.add_delay(figure, d + "s");
              d = parseFloat(i / 10).toFixed(2);
              _this.add_delay(bg, d + "s");
              bg.addClass("load");
              figure.addClass("unload");
            },
          );

          setTimeout(function() {
            $(".w_i_loader").fadeTo(200, 1);

            setTimeout(function() {
              _this._col_slider.waitForImages(true).done(function() {
                var tot = _this._col_slider.find(".c-slide").length;

                for (var j = 0; j <= tot; j++) {
                  _this._col_slider.slick("slickRemove", tot - j);
                }

                for (var i = 0; i < obj[t]["html"].length; i++) {
                  _this._col_slider.slick(
                    "slickAdd",
                    _this.make_slide(
                      obj[t]["html"][i],
                      obj[t]["alt"][i],
                      obj[t]["img"][i],
                    ),
                  );
                }

                $(".w_i_loader").fadeTo(200, 0, function() {
                  $("#subcategory_colors .w-c-slider .c-slide figure").each(
                    function(i) {
                      var figure = $(this);
                      var bg = $(this).find(".bg");

                      var f_delay = 0.41;
                      var d = parseFloat(i / 10).toFixed(2);

                      _this.add_delay(figure, d + "s");
                      figure.addClass("fade");

                      d = parseFloat(i / 10 + f_delay).toFixed(2);
                      _this.add_delay(bg, d + "s");
                      bg.addClass("unload");
                    },
                  );
                });
              });
            }, 210);
          }, 980);
        },
        error: function() {
          console.log(
            "Si è verificato un errore durante la procedura di recupero",
          );
        },
      });
    },

    make_slide: function(markup, alt, img) {
      var html = "";
      html += '<div class="c-slide new c_s_20">';
      html +=
        '<figure class="is-pz" data-href="/public/images/' +
        img +
        '" data-caption="' +
        alt +
        '">';
      html +=
        '<img src="/public/images/thumbs/' +
        img +
        '" class="img-responsive" alt="' +
        alt +
        '">';
      html += '<div class="bg load"></div>';
      html += '<div class="filter"></div>';
      html += "<figcaption>";
      html += markup;
      html += "</figcaption></figure></div>";
      return html;
    },

    start_page_animation: function(href) {
      var _this = this;
      var nav = $("header nav");

      $("#suggestions-select").hide().find("ul").empty();
      $("#search-i").val("").blur();
      var result_c = $("#result_container");
      result_c.empty();

      if (nav.hasClass("open")) {
        nav.removeAttr("class");
        setTimeout(function() {
          //$("#w-loader").removeClass();
          _this._body.addClass("a-link");
          setTimeout(function() {
            if (href) _this._window.location = href;
            else _this._window.location.reload();
          }, 320);
        }, 550);
      } else {
        _this._body.addClass("a-link");

        setTimeout(function() {
          $("#w-loader").removeClass();
          if (href) _this._window.location = href;
          else _this._window.location.reload();
        }, 300);
      }
    },

    load_h_iframe: function() {
      var _this = this;
      $("#w-video-player").addClass("is-open");

      $(document).keyup(function(e) {
        if (e.keyCode == 27) {
          if (_this._ishome && $("#w-video-player").hasClass("is-open"))
            _this.unload_h_iframe();
        }
      });
    },

    unload_h_iframe: function() {
      var iframe = $("#i-yt-video")[0].contentWindow;
      $("#w-video-player").removeClass("is-open");
      iframe.postMessage('{"method":"pause"}', "*");
    },

    load_subcatplay_iframe: function(element) {
      var _this = this;
      var iframe = $("#i-yt-video");
      var url = "";

      url = $(element).data("link");

      $("#w-video-player").addClass("is-open");

      // Check if the user has accepted the cookie banner
      if (_iub.cs.consent.purposes !== undefined) {
        var purposes_iub = Object.keys(_iub.cs.consent.purposes);
        if (_iub.cs.consent.purposes[3] == true) {
          iframe.attr("src", url);
        }
      }

      $(document).keyup(function(e) {
        if (e.keyCode == 27) {
          if (_this._ishome && $("#w-video-player").hasClass("is-open"))
            _this.unload_h_iframe();
        }
      });
    },

    box_check: function() {
      var n = 0;
      if (this._ax < 0) {
        this._ax = 0;
      }
      if (this._ay < 0) {
        this._ay = 0;
      }
      if (this._ax > document.documentElement.clientWidth - n) {
        this._ax = document.documentElement.clientWidth - n;
      }
      if (this._ay > document.documentElement.clientHeight - n) {
        this._ay = document.documentElement.clientHeight - n;
      }
    },

    loaded: function() {
      var _this = this;

      if (this._ishome) {
        this.create_controls();
        this.create_wrap_player();
        this.set_slider_options();
      }

      if (this._isSubcat) {
        this.create_wrap_player();
      }

      function iubendaCheck() {
        // Remove iubenda cookie message
        setTimeout(function() {
          if (_iub.cs.consent.purposes !== undefined) {
            let purposes_iub = Object.keys(_iub.cs.consent.purposes);

            for (let i = 0; i < purposes_iub.length; i++) {
              if (_iub.cs.consent.purposes[purposes_iub[i]] == true) {
                // Hide cookie message for enabled purposes
                $('.content-before-consent-' + purposes_iub[i]).each(function(_, el) {
                  el.style.display = 'none';
                });

                // Send events to GTM
                switch (purposes_iub[i]) {
                  case '2':
                    // Attivatore Tag Manager categoria Interazioni Semplici
                    dataLayer.push({
                      event: 'iubenda-interazioni-semplici',
                    });
                    break;
                  case '3':
                    // Attivatore Tag Manager categoria Esperienza Migliorata
                    dataLayer.push({
                      event: 'iubenda-esperienza-migliorata',
                    });
                    break;
                  case '4':
                    // Attivatore Tag Manager categoria Misurazione
                    dataLayer.push({ event: 'iubenda-misurazione' });
                    break;
                  case '5':
                    // Attivatore Tag Manager categoria Pubblicità
                    dataLayer.push({ event: 'iubenda-pubblicita' });
                    break;
                }
              } else {
                // Show cookie message for disabled purposes
                $('.content-before-consent-' + purposes_iub[i]).each(function(_, el) {
                  el.style.display = 'flex';
                });
              }
            }
          } else {
            // Show cookie message for disabled purposes
            $('.content-before-consent').each(function(_, el) {
              el.style.display = 'block';
            });
          }
          _iub.cs.api.activateSnippets();
        }, 500);
      }

      iubendaCheck();

      if (this._isgallery) {
        this.set_gallery_options();
      }

      this._isloaded = true;
      this.resize();
      this.init_events();

      if (!this._istablet && !this._ismobile && this._vw > 1260) {
        this._body.addClass("s_sb").removeClass("ns_sb");
        this._scrollbar = Scrollbar.init(
          document.getElementById("inner-scroll"),
          {
            speed: 0.8,
            damping: 0.08,
          },
        );

        this.scrollbar_scroll();

        if (_this._scrollbar) {
          _this._scrollbar.scrollTo(0, 5, 1);
          _this._scrollbar.scrollTo(0, 0, 1);
          _this._anim_items_selector.each(function(i, item) {
            _this.check_in_view(item);
          });
        }
      } else {
        this._body.addClass("ns_sb").removeClass("s_sb");
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          6,
        );
        $("#inner-scroll").css({
          height: "auto",
        });
        for (var i = 0; i < this._anim_items_selector.length; i++)
          this.make_watcher(this._anim_items_selector[i]);
      }

      this.resize();

      if (_this._vw <= 767) {
        var w = $("#c_breadcrumb .breadcrumb").width();
        $("#c_breadcrumb .breadcrumb").scrollLeft(w);
      }

      if (_this.check_element($("#subcategory_colors"))) {
        _this.set_colors_slider();
      }

      if (_this._ishome) {
        $("#h-pv-i").val("").blur();
      }

      if (_this._ispv) {
        if (this._istablet || this._ismobile) {
          $("#pv-i").blur();
        } else document.getElementById("pv-i").focus();
      }

      this.remove_preloader(this);
    },
    scroll: function() {
      var currentScroll = $(window).scrollTop();
      var direction =
        currentScroll > this._previus_scroll; /* true = down ; false = up */

      if (currentScroll < 0) currentScroll = 0;

      if (direction) {
        /*down*/
        if (currentScroll >= 10) {
          if (this._vw > 1280 && this._p_id == "idp-2")
            this._body.addClass("nav_changed");

          if (this._h_s_controls)
            this._h_s_controls.removeClass().addClass("changed");

          if (currentScroll >= this._vh_middle) {
            $(".w_scroll_down").addClass("hide-i");
            if (this._h_s_controls)
              this._h_s_controls.removeClass().addClass("changed hide-i");
          }
        }
      } else {
        if (currentScroll <= 10) {
          if (this._vw > 1280 && this._p_id == "idp-2")
            this._body.removeAttr("class");

          if (this._h_s_controls) this._h_s_controls.removeClass();
        }
        if (currentScroll <= this._vh_middle) {
          $(".w_scroll_down").removeClass("hide-i");

          if (this._h_s_controls) this._h_s_controls.removeClass("hide-i");
        }
      }
      this._previus_scroll = currentScroll;
    },
    resize: function() {
      if (this._isios) this._is_resized = true;

      (this._vw = this._window.innerWidth),
        (this._vh = this._window.innerHeight),
        (this._vh_middle = this._vh / 2);

      this.config_block();

      this.fit_footer();

      if (this._scrollbar)
        if (Scrollbar.has(document.getElementById("inner-scroll")))
          this.update_elements();

      if (this._vw <= 1280 && this._ishome) this._body.removeAttr("class");

      var fb_news_list = $("#fb-home .fb-news");

      if (this._vw <= 768 && this._ishome) fb_news_list.attr("data-speed", 1);
      else {
        fb_news_list.eq(0).attr("data-speed", 2.5);
        fb_news_list.eq(1).attr("data-speed", 1.3);
        fb_news_list.eq(2).attr("data-speed", 0.1);
        fb_news_list.eq(3).attr("data-speed", 2);
      }

      if (this.check_element($("#w-img")))
        $("#w-img").find("img").css("height", this._vh);

      if (this.check_element($("#subcategory_colors"))) {
        if (this._body.hasClass("s_sb") && this._vw < 767)
          $(".colors-menu").parent().attr("data-speed", "0.6");

        if (this.check_element($(".slick-track"))) {
          setTimeout(function() {
            var h = $(".slick-track").height();
            $("#subcategory_colors .w-c-slider .col-slider").height(h);
          }, 200);
        }
      }

      if (this._ispv) {
        if (this._map) {
          google.maps.event.trigger(this._map, "resize");
        }
      }

      if (this._ismission) {
        if (this._vw <= 991) {
          $(".h-scroll[data-pos='b_m_t']").each(function() {
            var h_s = $(this);
            var mem = h_s.attr("data-speed");

            if (h_s.attr("data-mem") === undefined) h_s.attr("data-mem", mem);

            h_s.attr("data-speed", 1.1);
          });
        } else {
          $(".h-scroll[data-pos='b_m_t']").each(function() {
            var h_s = $(this);
            var mem = h_s.attr("data-mem");
            h_s.attr("data-speed", mem).removeAttr("data-mem");
          });
        }
      }
    },
    update_elements: function() {
      var _this = this;
      setTimeout(function() {
        _this._scrollbar.scrollTo(0, 5, 1);
        _this._scrollbar.scrollTo(0, 0, 1);
      }, 100);

      this._scrollbar.update();
      (this._vh = this._window.innerHeight), (this._vh_middle = this._vh / 2);
      this._offset = this._scrollbar.scrollTop;
      this.transform_elements();
    },
    check_element: function(element) {
      return element.length > 0;
    },
    config_block: function() {
      var parents = $(".g_res_i");
      if (this._vw > 991)
        parents.each(function() {
          var h = 0;
          var g_res = $(this).find(".g-res");
          var g_res_h = g_res.outerHeight();
          if (g_res_h !== undefined) h = g_res_h;
          var item = $(this).find(".s-res");
          setTimeout(function() {
            item.css("height", h + "px");
          }, 100);
        });
      else
        parents.each(function() {
          var item_a = $(this).find(".g-res");
          var item_b = $(this).find(".s-res");
          item_a.css("height", "auto");
          item_b.css("height", "auto");
        });
    },
    fit_footer: function() {
      var f_s1 = $("footer .f-w-s1");
      var f_s2 = $("footer .f-w-s2");
      if (this._vw <= 480) {
        f_s2.css({
          height: "auto",
        });
      } else
        f_s2.css({
          height: f_s1.outerHeight(),
        });
    },
    set_colors_slider: function() {
      var c_s_a_left = $("#c-s-arrow-left");
      var c_s_a_right = $("#c-s-arrow-right");

      if (!this.check_element($("#w-gallery-grid"))) {
        var html = '<div id="w-gallery-grid">';
        html += '<div class="w_i_loader">';
        html += '<div class="infinite-loader"></div>';
        html += "</div>";
        html += "</div>";
        $("body").append(html);
      }

      this._col_slider
        .slick({
          slidesToShow: 5,
          accessibility: false,
          cssEase: "cubic-bezier(0.4, 0, 0.2, 1)",
          edgeFriction: 0.03,
          infinite: false,
          speed: 900,
          arrows: true,
          waitForAnimate: true,
          prevArrow: c_s_a_left,
          nextArrow: c_s_a_right,
          responsive: [
            {
              breakpoint: 2561,
              settings: {
                slidesToShow: 7,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 1921,
              settings: {
                slidesToShow: 6,
                slidesToScroll: 2,
              },
            },

            {
              breakpoint: 1681,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 1367,
              settings: {
                slidesToShow: 6,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 350,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ],
        })
        .slickLightbox({
          src: "data-href",
          itemSelector: ".c-slide figure",
          background: "rgba(255,255,255,0)",
          useHistoryApi: true,
          caption: function(element, info) {
            return $(element).data("caption");
          },
          layouts: {
            closeButton:
              '<div class="w-c-btn"><div class="close-w-v-p"></div></div>',
          },
        })
        .on({
          "show.slickLightbox": function() {
            var m = 90;
            $(".slick-lightbox-slick-img")
              .on("mouseover", function() {
                $(this).addClass("scaled");
              })
              .on("mouseout", function() {
                $(this).removeClass("scaled");
              })
              .on("mousemove", function(e) {
                $(this).css({
                  "transform-origin":
                    ((e.pageX - $(this).offset().left) / $(this).width()) * m +
                    "% " +
                    ((e.pageY - $(this).offset().top) / $(this).height()) * m +
                    "%",
                });
              });

            var slick = $(".slick-lightbox");

            html = '<div class="w_arrows">';
            html +=
              '<div class="arrow gg-prev" data-direction="prev"><figure><img src="/content/assets/images/icons/prev.svg" alt="arrow prev"/></figure></div>';
            html +=
              '<div class="arrow gg-next" data-direction="next"><figure><img src="/content/assets/images/icons/next.svg" alt="arrow next"/></figure></div>';
            html += "</div>";

            slick.append(html);

            slick.find(".arrow").css("opacity", 0);

            slick.on("click", ".arrow", function() {
              var dir = $(this).data("direction");
              if (dir == "next") slick.find(".slick-next").click();
              else slick.find(".slick-prev").click();
            });

            slick.find(".slick-lightbox-slick-item-inner").each(function() {
              var html =
                '<div class="w_i_loader"><div class="infinite-loader"></div></div>';
              $(this).append(html).find("img").css({
                opacity: 0,
              });
            });

            $("#w-gallery-grid .w_i_loader").css("opacity", 1);
            slick.css("opacity", 0);
            $("#w-gallery-grid").addClass("is-open");
            setTimeout(function() {
              $("#w-gallery-grid .w_i_loader").css("opacity", 0);
              $(".slick-lightbox").css("opacity", 1);
            }, 1200);
          },
          "shown.slickLightbox": function() {
            var slick = $(".slick-lightbox");

            slick.waitForImages(
              function() {
                //alert('All images have loaded.');
              },
              function(loaded, count, success) {
                //alert(loaded + ' of ' + count + ' images has ' + (success ? 'loaded' : 'failed to load') +  '.');
                var p = $(this).parent();
                p.find(".w_i_loader").remove();
                $(this).fadeTo(500, 1);
              },
            );
            slick.find(".arrow").css("opacity", 1);
          },
          "hide.slickLightbox": function() {
            $(".slick-lightbox").css("opacity", 0);
            $("#w-gallery-grid").removeAttr("class");
          },
        });

      if (this.check_element($("#subcategory_colors"))) {
        var h = $(".slick-track").height();
        $("#subcategory_colors .w-c-slider .col-slider").height(h);
      }
    },
    set_slider_options: function() {
      var h4 = $("#h-s-controls h4");
      this._h_slider = $("#slick-slider");
      var h_slider = this._h_slider;
      var h_s_a_left = $("#h-s-arrow-left");
      var h_s_a_right = $("#h-s-arrow-right");
      var _this = this;
      var index = 0;
      var is_animating = false;

      this._h_slider.on("init", function(slick) {
        var slide_active = $(".slick-active");
        var title = slide_active.find("figure").attr("data-title");
        h4.html(title);
      });

      this._h_slider.slick({
        accessibility: false,
        cssEase: "cubic-bezier(0.4, 0, 0.2, 1)",
        edgeFriction: 0.03,
        infinite: false,
        speed: 900,
        arrows: true,
        prevArrow: h_s_a_left,
        nextArrow: h_s_a_right,
      });

      h_s_a_left.on("click", function() {
        if (is_animating) return false;

        h_s_a_right.removeClass("disabled");
        $(this).removeClass("disabled");

        if (index <= 0) {
          $(this).addClass("disabled");
          index = 0;
          return;
        }

        index--;

        if (index <= 0) {
          $(this).addClass("disabled");
        }
        _this._h_s_controls.addClass("hide-title");
        h_slider.slick("slickPrev");

        is_animating = true;
      });

      h_s_a_right.on("click", function() {
        if (is_animating) return false;

        h_s_a_left.removeClass("disabled");
        $(this).removeClass("disabled");
        var tot = $(".slick-slide").length - 1;

        if (index >= tot) {
          $(this).addClass("disabled");
          index = tot;
          return;
        }

        index++;

        if (index >= tot) {
          $(this).addClass("disabled");
        }

        _this._h_s_controls.addClass("hide-title");
        h_slider.slick("slickNext");

        is_animating = true;
      });

      this._h_slider.on("swipe", function(event, slick, direction) {
        if (is_animating) return false;

        if (direction == "left") h_s_a_right.click();
        else h_s_a_left.click();
      });

      this._h_slider.on("afterChange", function(event, slick, currentSlide) {
        var c_slide = $(slick.$slides[currentSlide]);
        var title = c_slide.find("figure").attr("data-title");
        h4.html(title);
        _this._h_s_controls.removeClass("hide-title");
        is_animating = false;
      });
    },
    set_gallery_options: function() {
      /* VARIANTE GALLERY */

      var html = '<div id="w-gallery-grid">';
      html += '<div class="w_i_loader">';
      html += '<div class="infinite-loader"></div>';
      html += "</div>";
      html += "</div>";
      $("body").append(html);

      this._gallery = $(".is_gallery");
      this._gallery.slickLightbox({
        src: function(element, info) {
          return $(element).attr("data-href");
        },
        background: "rgba(255,255,255,0)",
        itemSelector: ".i-gallery figure",
        useHistoryApi: true,
        caption: function(element, info) {
          if ($(element).parent().hasClass("is-pz"))
            return $(element).data("caption");
          else return "";
        },
        layouts: {
          closeButton:
            '<div class="w-c-btn"><div class="close-w-v-p"></div></div>',
        },
      });
      this._gallery.slickLightbox().on({
        "show.slickLightbox": function() {
          if (!$(this).attr("id")) {
            /* code for pan zoom */
            var m = 90;
            $(".slick-lightbox-slick-img")
              .on("mouseover", function() {
                $(this).addClass("scaled");
              })
              .on("mouseout", function() {
                $(this).removeClass("scaled");
              })
              .on("mousemove", function(e) {
                $(this).css({
                  "transform-origin":
                    ((e.pageX - $(this).offset().left) / $(this).width()) * m +
                    "% " +
                    ((e.pageY - $(this).offset().top) / $(this).height()) * m +
                    "%",
                });
              });
          }

          var slick = $(".slick-lightbox");

          html = '<div class="w_arrows">';
          html +=
            '<div class="arrow gg-prev" data-direction="prev"><figure><img src="/content/assets/images/icons/prev.svg" alt="arrow prev"/></figure></div>';
          html +=
            '<div class="arrow gg-next" data-direction="next"><figure><img src="/content/assets/images/icons/next.svg" alt="arrow next"/></figure></div>';
          html += "</div>";

          slick.append(html);

          slick.find(".slick-lightbox-slick-item-inner").each(function() {
            var html =
              '<div class="w_i_loader"><div class="infinite-loader"></div></div>';
            $(this).append(html).find("img").css({
              opacity: 0,
            });
          });

          slick.find(".arrow").css("opacity", 0);

          slick.on("click", ".arrow", function() {
            var dir = $(this).data("direction");
            if (dir == "next") slick.find(".slick-next").click();
            else slick.find(".slick-prev").click();
          });

          $("#w-gallery-grid .w_i_loader").css("opacity", 1);
          slick.css("opacity", 0);

          $("#w-gallery-grid").addClass("is-open");
          setTimeout(function() {
            $("#w-gallery-grid .w_i_loader").css("opacity", 0);
            $(".slick-lightbox").css("opacity", 1);
          }, 1200);
        },
        "shown.slickLightbox": function() {
          var slick = $(".slick-lightbox");

          slick.waitForImages(
            function() {
              //alert('All images have loaded.');
            },
            function(loaded, count, success) {
              //alert(loaded + ' of ' + count + ' images has ' + (success ? 'loaded' : 'failed to load') +  '.');
              var p = $(this).parent();
              p.find(".w_i_loader").remove();
              $(this).fadeTo(500, 1);
            },
          );

          slick.find(".arrow").css("opacity", 1);
        },
        "hide.slickLightbox": function() {
          $(".slick-lightbox").css("opacity", 0);
          $("#w-gallery-grid").removeAttr("class");
        },
      });
    },
    open_menu: function(state) {
      var w_menu = $("header nav");
      if (state) {
        w_menu.addClass("open");
        return;
      }
      w_menu.removeClass("open");
    },
    add_delay: function(elem, delay) {
      if (delay === undefined) return;
      elem.css("-webkit-transition-delay", delay);
      elem.css("transition-delay", delay);
    },
    create_controls: function() {
      var html = '<div id="h-s-controls">';
      html += '<figure id="h-s-arrow-left" class="disabled">';
      html += '<img src="/content/assets/images/icons/arrow_left.svg"/>';
      html += "</figure>";
      html += "<h4></h4>";
      html += '<figure id="h-s-arrow-right">';
      html += '<img src="/content/assets/images/icons/arrow_right.svg"/>';
      html += "</figure>";
      html += "</div>";
      $("body").append(html);
      this._h_s_controls = $("#h-s-controls");
    },
    create_wrap_player: function() {
      // Gestione messaggio con l'avviso dei cookie da accettare per vedere il video [categoria miglioramento dell'esperienza]
      var lang = this._language;
      var contentbeforeconsent = "";
      switch (lang) {
        case "it":
          contentbeforeconsent =
            'Accettare i cookie della categoria "miglioramento dell’esperienza" per vedere il video, <span class="open-cookie-preferences">clicca qui per personalizzare i cookie</span>';
          break;
        case "en":
          contentbeforeconsent =
            'Accept the cookies from the "experience enhancement" category to watch the video, <span class="open-cookie-preferences">click here to customize cookies</span>';
          break;
        case "fr":
          contentbeforeconsent =
            'Acceptez les cookies de la catégorie "amélioration de l’expérience" pour visionner la vidéo, <span class="open-cookie-preferences">cliquez ici pour personnaliser les cookies</span>';
          break;
      }

      var html = '<div id="w-video-player">';
      html +=
        '<div class="content-before-consent content-before-consent-3"><a href="#" class="iubenda-cs-preferences-link">' +
        contentbeforeconsent +
        "</a></div>";
      html += '<div class="w-c-btn"><div class="close-w-v-p"></div></div>';
      html +=
        '<div class="c_s_8 c_s_ofst_2 c_x_10 c_x_ofst_1 w-c-v embed-responsive embed-responsive-16by9">';
      html += '<div class="w_i_loader">';
      html += '<div class="infinite-loader"></div>';
      html += "</div>";
      html +=
        '<iframe id="i-yt-video" width="560" height="315" class="_iub_cs_activate"  data-iub-purposes="3" data-suppressedsrc="" frameborder="0" allowfullscreen></iframe>';
      html += "</div></div>";
      $("body").append(html);

      var iframe = $("#i-yt-video");
      var url = "";
      var id_video = 0;
      switch (lang) {
        case "it":
          id_video = 227410756;
          break;
        case "en":
          id_video = 227411571;
          break;
        case "fr":
          id_video = 227410024;
          break;
      }
      url =
        "https://player.vimeo.com/video/" +
        id_video +
        "?color=37424a&title=0&byline=0&portrait=0";
      iframe.attr("data-suppressedsrc", url);
    },

    scrollbar_scroll: function() {
      var _this = this;
      this._scrollbar.addListener(function(status) {
        var direction = status.direction.y;
        if (!_this._ismobile && !_this._istablet) {
          if (!_this._nav_bar.hasClass("no_change")) {
            if (direction == "up") {
              if (_this._scrollbar.scrollTop <= 10) {
                if (
                  _this._vw > 1280 &&
                  _this._p_id == "idp-2" &&
                  !$("#search_wrapper").hasClass("open")
                )
                  _this._body.removeAttr("class");

                if (_this._h_s_controls) _this._h_s_controls.removeClass();
              }
              if (_this._scrollbar.scrollTop <= _this._vh_middle) {
                if (_this._h_s_controls) {
                  $(".w_scroll_down").removeClass("hide-i");
                  _this._h_s_controls.removeClass("hide-i");
                }
              }
            }

            if (direction == "down") {
              if (_this._scrollbar.scrollTop >= 10) {
                if (_this._vw > 1280 && _this._p_id == "idp-2")
                  _this._body.addClass("nav_changed");

                if (_this._h_s_controls)
                  _this._h_s_controls.removeClass().addClass("changed");

                if (_this._scrollbar.scrollTop >= _this._vh_middle) {
                  if (_this._h_s_controls) {
                    $(".w_scroll_down").addClass("hide-i");
                    _this._h_s_controls
                      .removeClass()
                      .addClass("changed hide-i");
                  }
                }
              }
            }
          }
        }

        // _this._anim_items_selector.each(function(i, item){
        //     _this.check_in_view(item);
        // });
        _this.setSelectors();

        _this.transform_elements();
      });
    },
    setSelectors: function() {
      var self = this;
      self._anim_items_selector.each(function(i, item) {
        self.check_in_view(item);
      });
    },
    check_in_view: function(item) {
      if (this._scrollbar.isVisible(item)) {
        var a_i = $(item);
        if (!a_i.hasClass("anim_up")) {
          var delay = a_i.attr("data-delay");
          this.add_delay(a_i, delay);
          a_i.addClass("anim_up");
        }
      }
    },
    transform_elements: function() {
      var _this = this;
      this._has_scroll_selector.each(function(i, hs) {
        var a_i = $(hs);
        var delta = parseFloat(a_i.attr("data-speed"));
        var is_parent = a_i.hasClass("container-fluid");
        var p_s = a_i.parents(".p_s");
        var pos = {
          x: 0,
          y: 0,
          z: 0,
        };
        var data = {
          c: 0,
          j: 0,
          k: 0,
          q: 0,
          h: 0,
          f_h: 0,
        };

        switch (a_i.attr("data-pos")) {
          case "0_t":
          case "0_b":
            data.h = _this._scrollbar.scrollTop * -(delta / 10);
            pos.y = data.h + "px";
            if (_this._scrollbar.isVisible(hs))
              _this.transform_element(a_i, pos.x, pos.y, pos.z);
            break;

          case "b_m":
            data.c = _this._scrollbar.scrollTop + _this._vh_middle;
            data.j = a_i.offset().top + _this._scrollbar.scrollTop;
            data.k = data.j + a_i.outerHeight();
            data.q = (data.k - data.j) / 2 + data.j;
            data.h = (data.c - data.q) * -(delta / 10);
            pos.y = data.h + "px";
            //if(_this._is_scroll && a_i.parents(".container-fluid").hasClass("h-show")) {
            if (_this._is_scroll) {
              if (data.h >= 0)
                if (_this._scrollbar.isVisible(hs))
                  _this.transform_element(a_i, pos.x, pos.y, pos.z);
                else if (_this._scrollbar.isVisible(hs))
                  _this.transform_element(a_i, pos.x, 0, pos.z);
            }
            break;

          case "b_m_t":
            data.c = _this._scrollbar.scrollTop + _this._vh_middle;
            data.j = a_i.offset().top + _this._scrollbar.scrollTop;
            data.k = data.j + a_i.outerHeight();
            data.q = (data.k - data.j) / 2 + data.j;
            data.h = (data.c - data.q) * -(delta / 10);
            pos.y = data.h + "px";
            //if(_this._is_scroll && a_i.parents(".container-fluid").hasClass("h-show"))
            if (_this._is_scroll) {
              if (_this._scrollbar.isVisible(hs))
                _this.transform_element(a_i, pos.x, pos.y, pos.z);
            }
            break;

          default:
            //_this._is_scroll = _this._scrollbar.isVisible(hs) && is_parent;
            _this._is_scroll = is_parent;
            if (_this._is_scroll) {
              if (!a_i.addClass("h-show")) a_i.addClass("h-show");
            }
            break;
        }
      });
    },
    transform_element: function(i, x, y, z) {
      i.css({
        "-webkit-transform": "translate3d(" + x + ", " + y + ", " + z + ")",
        "-ms-transform": "translate3d(" + x + ", " + y + ", " + z + ")",
        transform: "translate3d(" + x + ", " + y + ", " + z + ")",
      });
    },
    make_watcher: function(element) {
      var watcher = scrollMonitor.create(element);
      watcher.stateChange(this.show_element);
      watcher._this = this;
      this.show_element.call(watcher);
    },
    show_element: function() {
      var item = $(this.watchItem);
      if (!this.isInViewport) return;
      if (
        this.isBelowViewport ||
        this.isFullyInViewport ||
        this.isAboveViewport
      ) {
        var delay = item.attr("data-delay");
        this._this.add_delay(item, delay);
        item.addClass("anim_up");
      }
    },
    social_wall: function() {
      var _this = this;

      // if(!this._cookie_state){
      //   if (this.check_element($("#fb-home")))
      //       $("#fb-home").hide();
      //   return false;
      // }

      $.ajax({
        type: "POST",
        url: _this._baseurl + "it/getjsonfb",
        dataType: "json",
        data: {
          limit: 50,
        },
        success: function(result) {
          var fb_bricks = $("#fb-home .fb-news");
          $("#fb-home .fb-news figure img")
            .css("opacity", "0")
            .on("load", function() {
              $(this).fadeTo(250, 1);
            });
          for (var i = 0; i < result.length; i++) {
            _this.fill_fb_cards($(fb_bricks[i]), result[i]);
          }
        },
        error: function() { },
      });
    },
    remove_preloader: function(_this) {
      setTimeout(function() {
        $("#lines-logo .line").addClass("go_away");
        setTimeout(function() {
          $("#bg-loader").addClass("go_away");
          $("#w-loader").addClass("go_away");
          $("#w_h_s").addClass("change");

          if (_this._ispv) {
            if (navigator.geolocation) {
              _this.init_map();
              if (localStorage.getItem("city")) {
                /* PROVENGO DA HOME PUNTI VENDITA */
                var h_city = localStorage.getItem("city");
                $("#pv-i").val(h_city);
                $("#find-stores").click();
                localStorage.removeItem("city");
              } else {
                navigator.geolocation.getCurrentPosition(function(position) {
                  $("#punti_vendita_header .w_i_loader").show();
                  _this._lat = position.coords.latitude;
                  _this._lng = position.coords.longitude;
                  setTimeout(function() {
                    _this.find_clotest_market(_this._lat, _this._lng);
                  }, 100);
                });
              }
            }
          }
        }, 650);
      }, 920);
    },
    fill_fb_cards: function(brick, data) {
      var agttachments = data;

      brick.find("a").attr({
        href: agttachments["url"],
      });

      brick.find("figure img").attr({
        src: agttachments["media"]["image"]["src"],
        alt: agttachments["description"],
      });

      var mex = agttachments["description"];
      mex = mex.substring(0, 150) + "...";
      var link = agttachments["target"]["url"];
      var type = "";

      if (mex.indexOf("#press") != -1) type = "press";
      else if (link.indexOf("https://www.facebook.com") != -1) type = "news";
      else type = "link";

      var img_icon_url = "";
      var h5 = "";
      switch (type) {
        case "press":
          img_icon_url = "/content/assets/images/icons/social/press.svg";
          h5 = "Press News";
          break;
        case "news":
          img_icon_url = "/content/assets/images/icons/social/facebook.svg";
          h5 = "News";
          break;
        case "link":
          img_icon_url = "/content/assets/images/icons/social/link.svg";
          h5 = "Link";
          break;
      }

      var p = mex;
      var lang = this._language;
      var h6 = "scopri di più";
      switch (lang) {
        case "en":
          h6 = "find out more";
          break;
        case "fr":
          h6 = "en savoir plus";
          break;
      }

      brick.find(".w-text .inner-text img").attr("src", img_icon_url);
      brick.find(".w-text .inner-text h5").html(h5);
      brick.find(".w-text .inner-text p").html(p);
      brick.find(".w-text .inner-text h6").html(h6);
    },
  };

  // Init events
  app.init();

  this.onload = function() {
    if (app._setlocal) app.loaded();
  };

  this.onscroll = function() {
    if (app._setlocal) app.scroll();
  };

  this.onresize = function() {
    if (app._setlocal) app.resize();
  };
})();
